import React, { useEffect, useState } from "react";
import { NonStreamReportValue, StreamReportValue, } from "../../features/Markets/Equity/commonTablemethods";
import CorporateGeneric from "./CorporateActions/corporateGeneric";
import MarketdepthGeneric from "./MarketDepth/MarketdepthGeneric";
import SlideNewsGeneric from "./News/slidenewsGeneric";
import ResearchCallGeneric from "./ResearchCalls/ResearchCallGeneric";
import PivotPoints from "../pivotPoints";
export const marketDepthColumn = [
    {
        columnName: "Bids",
        key: "bidPrice",
    },
    {
        columnName: "Orders",
        key: "bidOrder",
        tdCustomFunction: NonStreamReportValue,
    },
    {
        columnName: "Qty",
        key: "bidQuantity",
        tdCustomFunction: NonStreamReportValue,
    },
    {
        columnName: "Ask",
        key: "askPrice",
        tdCustomFunction: StreamReportValue,
    },
    {
        columnName: "Orders",
        key: "askOrder",
        tdCustomFunction: StreamReportValue,
    },
    {
        columnName: "Qty",
        key: "askQuantity",
        tdCustomFunction: StreamReportValue,
    },
];
const SlidingBottom = (props) => {
    var _a, _b, _c, _d, _e;
    const [pivotPoint, setPivotPoint] = useState([]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if ((_b = (_a = props.scripDetail) === null || _a === void 0 ? void 0 : _a.quote) === null || _b === void 0 ? void 0 : _b.quoteObj) {
            setPivotPoint([
                {
                    pivotName: "Open",
                    pivotValue: (_e = (_d = (_c = props.scripDetail) === null || _c === void 0 ? void 0 : _c.quote) === null || _d === void 0 ? void 0 : _d.quoteObj) === null || _e === void 0 ? void 0 : _e.open,
                },
                {
                    pivotName: "Low",
                    pivotValue: (_h = (_g = (_f = props.scripDetail) === null || _f === void 0 ? void 0 : _f.quote) === null || _g === void 0 ? void 0 : _g.quoteObj) === null || _h === void 0 ? void 0 : _h.low,
                },
                {
                    pivotName: "High",
                    pivotValue: (_l = (_k = (_j = props.scripDetail) === null || _j === void 0 ? void 0 : _j.quote) === null || _k === void 0 ? void 0 : _k.quoteObj) === null || _l === void 0 ? void 0 : _l.high,
                },
                {
                    pivotName: "Prev Close",
                    pivotValue: (_p = (_o = (_m = props.scripDetail) === null || _m === void 0 ? void 0 : _m.quote) === null || _o === void 0 ? void 0 : _o.quoteObj) === null || _p === void 0 ? void 0 : _p.close,
                },
            ]);
        }
    }, [props.scripDetail]);
    return (React.createElement("div", null,
        React.createElement(PivotPoints, { pointPoints: pivotPoint }),
        React.createElement(MarketdepthGeneric, { columns: marketDepthColumn, marketDepth: (_b = (_a = props.scripDetail) === null || _a === void 0 ? void 0 : _a.quote) === null || _b === void 0 ? void 0 : _b.marketDepth }),
        React.createElement(CorporateGeneric, { title: "Corporate Actions", corporateActions: (_c = props.scripDetail) === null || _c === void 0 ? void 0 : _c.events }),
        React.createElement(SlideNewsGeneric, { title: "News", news: (_d = props.scripDetail) === null || _d === void 0 ? void 0 : _d.news }),
        React.createElement(ResearchCallGeneric, { title: "Research Call", researchCall: (_e = props.scripDetail) === null || _e === void 0 ? void 0 : _e.researchCall })));
};
export default SlidingBottom;
